import { gql } from '@apollo/client/core';

export const deleteStationLog = gql`
  mutation deleteStationLog($id: String) {
    deleteStationLog(id: $id)
  }
`;
